import { useMenu } from '@/common/_hooks/MenuContext'

type propsTypes = {
  headClass?: string
  title?: string
  subTitle?: string
}

const PageTitle = ({ headClass, title, subTitle }: propsTypes) => {
  const { matchedMenu } = useMenu()
  return <div className={headClass}>{(title || matchedMenu?.menuNm) ?? ''}</div>
}

export default PageTitle
